import React, { useState, useEffect } from "react";
import { Loader ,Alert} from "./index";
import icon from "../assets/icons/contact_person.png";
import { ContactsText as text } from "../database/Text";
import { useGoogleLogin } from "@react-oauth/google";
import { random_bg_color } from "../utils/Helpers";
import { BsFillCircleFill } from "react-icons/bs";
import { useCallContext } from "../callContext/callContext";
import { ImSearch } from "react-icons/im";
import { formatDate } from "../utils/Helpers";
import {
  REDIRECT_URI,
  SCOPES,
  API_KEY,
  CLIENT_ID,
  CLIENT_SECERT,
} from "../utils/constants";
import { useMainContext } from "../callContext/MainContext";
const ContactsList = () => {
  const { callInfoApi, callsList, setCallsList,noNumAlert,setNoNumAlert } =
    useCallContext();
  let pageToken = localStorage.getItem("currPageToken");
  let accTkn = localStorage.getItem("currAccTkn");
  const [fetching, setFetching] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [error, setError] = useState(false);
  const [message, setMessage] = useState("");
  const localStorageContacts = localStorage.getItem("contactsList")
    ? JSON.parse(localStorage.getItem("contactsList"))
    : [];
  const [contacts, setContacts] = useState(localStorageContacts || []);
  const [initailContacts, setInitailContacts] = useState(
    localStorageContacts || []
  );
  const [loading, setLoading] = useState(false);
  const {language}=useMainContext();
  const login = useGoogleLogin({
    onSuccess: (codeResponse) => {
      setLoading(true);
      console.log(codeResponse);
      localStorage.setItem("code", codeResponse?.code);
      fetchContacts(codeResponse.code);
    },
    flow: "auth-code",
    scope: SCOPES,
  });

  const fetchContacts = (authorizationCode) => {
    const url = `https://www.googleapis.com/oauth2/v4/token`;
    console.log("authorizationCode is:::", authorizationCode);
    const data = {
      code: authorizationCode,
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECERT,
      redirect_uri: REDIRECT_URI,
      grant_type: "authorization_code",
    };

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams(data),
    })
      .then((response) => response.json())
      .then((tokenResponse) => {
        const accessToken = tokenResponse.access_token;
        const expiresIn = tokenResponse.expires_in;
        console.log("expires in :::", expiresIn);
        accTkn = tokenResponse.access_token;
        localStorage.setItem("currAccTkn", tokenResponse?.access_token);
        const expirationDate = new Date().getTime() + expiresIn * 1000;
        console.log("tokenResponse is:::", tokenResponse);
        if (tokenResponse?.error) {
          console.log("something went wrong");
          setError(true);
          setLoading(false);
          return;
        }
        const requestOptions = {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        };

        fetch(
          `https://people.googleapis.com/v1/people/me/connections?pageSize=10&personFields=names,phoneNumbers`,
          requestOptions
        )
          .then((response) => {
            if (response.status === 401) {
              // Token expired, refresh token
              refreshToken(tokenResponse.refresh_token);
            } else {
              return response.json();
            }
          })
          .then((data) => {
            if (data.error) {
              return;
            }
            if (JSON.stringify(data) !== "{}") {
              console.log("Contacts:", data.connections);
              setContacts(data.connections);
              setInitailContacts(data.connections);
              pageToken = data.nextPageToken;
              localStorage.setItem(
                "allNumsFetched",
                data.nextPageToken ? "no" : "yes"
              );
              if (data.nextPageToken) {
                localStorage.setItem("currPageToken", data.nextPageToken);
              }
              localStorage.setItem(
                "contactsList",
                JSON.stringify(data.connections)
              );
            }
            setMessage(text?.notFoundText?.[language]);
          })
          .catch((error) => {
            setError(true);
            console.error("Error retrieving contacts:", error);
          });
      })
      .catch((error) => {
        setError(true);
        console.error("Error retrieving access token:", error);
      })
      .finally(() =>
        setTimeout(() => {
          setLoading(false);
        }, 2000)
      );
  };

  const refreshToken = (refreshToken) => {
    setLoading(true);
    const url = `https://www.googleapis.com/oauth2/v4/token`;
    const data = {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECERT,
      refresh_token: refreshToken,
      grant_type: "refresh_token",
    };

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams(data),
    })
      .then((response) => response.json())
      .then((tokenResponse) => {
        const accessToken = tokenResponse.access_token;
        const expiresIn = tokenResponse.expires_in;
        const expirationDate = new Date().getTime() + expiresIn * 1000;
        if (tokenResponse?.error) {
          console.log("something went wrong");
          setError(true);
          setLoading(false);
          return;
        }
        const requestOptions = {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        };

        fetch(
          `https://people.googleapis.com/v1/people/me/connections?&pageSize=20&personFields=names,phoneNumbers&pageToken=${pageToken}`,
          requestOptions
        )
          .then((response) => response.json())
          .then((data) => {
            console.log("Contacts:", data.connections);
            setContacts(data.connections);
            setInitailContacts(data.connections);
            localStorage.setItem(
              "contactsList",
              JSON.stringify(data.connections)
            );
          })
          .catch((error) => {
            setError(true);
            console.error("Error retrieving contacts:", error);
          });
      })
      .catch((error) => {
        console.error("Error refreshing access token:", error);
      })
      .finally(() => setLoading(false));
  };
  const fetchNextContacts = () => {
    // setPageToken(localStorage.getItem("currPageToken"));
    const check = localStorage.getItem("allNumsFetched");
    if (check === "no") {
      pageToken = localStorage.getItem("currPageToken");
      accTkn = localStorage.getItem("currAccTkn");
      if (pageToken != "") {
        setFetching(true);
        const requestOptions = {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accTkn}`,
          },
        };

        fetch(
          `https://people.googleapis.com/v1/people/me/connections?pageSize=10&personFields=names,phoneNumbers&pageToken=${pageToken}`,
          requestOptions
        )
          .then((response) => response.json())
          .then((data) => {
            if (data.error) {
              return;
            }
            if (JSON.stringify(data) !== "{}") {
              console.log("Contacts:", data.connections);
              setContacts((prevContacts) => [
                ...prevContacts,
                ...data.connections,
              ]);
              setInitailContacts((prevContacts) => [
                ...prevContacts,
                ...data.connections,
              ]);
              localStorage.setItem(
                "contactsList",
                JSON.stringify([...contacts, ...data.connections])
              );
              pageToken = data.nextPageToken ? data.nextPageToken : "";
              console.log("hello is:::", pageToken);
              localStorage.setItem(
                "allNumsFetched",
                data.nextPageToken ? "no" : "yes"
              );
              setFetching(false);
              window.scrollTo(0, window.innerHeight);
            }
            if (data.nextPageToken) {
              localStorage.setItem("currPageToken", data.nextPageToken);
            }
            setMessage(text?.notFoundText?.[language]);
          })
          .catch((error) => {
            setError(true);
            console.error("Error retrieving contacts:", error);
          });
      }
    }
  };

  useEffect(() => {
    const cpyData = [...initailContacts];
    let filteredData = [];
    if (searchQuery !== "") {
      cpyData.forEach((contact) => {
        const { names, phoneNumbers } = contact;
        if (names && phoneNumbers) {
          const data = names.map((name) => {
            if (
              name.displayName.toLowerCase().includes(searchQuery.toLowerCase())
            ) {
              filteredData.push(contact);
            }
            return filteredData;
          });
          const newData = phoneNumbers.map((phoneNumber) => {
            if (phoneNumber.value.includes(searchQuery)) {
              filteredData.push(contact);
            }
            return filteredData;
          });
        }
        if(!phoneNumbers)
        {
          const data = names.map((name) => {
            if (
              name.displayName.toLowerCase().includes(searchQuery.toLowerCase())
            ) {
              filteredData.push(contact);
            }
            return filteredData;
          });
        }
      });

      console.log(filteredData);
      setContacts(filteredData);
    } else {
      setContacts(initailContacts);
    }
  }, [searchQuery]);

  const handleClick = (name, phone) => {
    if (phone) {
      console.log("name is:::", name);
      const CURRENT_NAME = "";
      const CURRENT_PHONE = phone[0].value;
      console.log(CURRENT_NAME, CURRENT_PHONE);

      const avatar = localStorage.getItem("currentSelectedAvatar")
        ? JSON.parse(localStorage.getItem("currentSelectedAvatar"))
        : [];
      const newCall = {
        call: {
          phone: CURRENT_PHONE,
          name: CURRENT_NAME,
          time: formatDate(new Date()),
        },
        avatar: avatar,
      };
      console.log("new call:::", newCall);
      setCallsList((oldList) => [newCall, ...oldList]);
      localStorage.setItem("callsList", JSON.stringify(callsList));
      callInfoApi(avatar, CURRENT_PHONE, "Contacts");
    } else {
      setNoNumAlert(true)
      console.log("No call is made since the values are absent");
    }
  };
 
  return (
    <div className="overflow-y-scroll fadeInOut -z-[1000] min-h-screen ">
      {contacts.length === 0 && initailContacts.length === 0 ? (
        <div className=" fixed cursor-pointer flex flex-col justify-center items-center  top-1/3 mt-16 left-1/2 -translate-x-1/2 ">
          <img src={icon} alt="contact" className="m-auto h-16" />
          <button
            type="submit"
            onClick={() => login()}
            className="text-center text-slate-400 m-auto border-2 rounded-md  my-4 p-2 border-gray-700"
          >
           {text?.allowText?.[language]}
          </button>
          {message && <h1 className="my-2 text-center">{message}</h1>}
          {error && (
            <h1 className="my-2 text-center w-full">
             {text?.wentWrongText?.[language]}
            </h1>
          )}
        </div>
      ) : (
        <div className="relative  w-full ">
          <div className="px-4  py-3 flex fixed w-full bg-white max-w-[500px] z-[2000]">
            <ImSearch size={30} color="grey" className="m-atuo" />
            <input
              type="text"
              className="w-full outline-none px-2 "
              placeholder="Search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
          <div className="pt-10 w-full ">
            {contacts &&
              contacts.length > 0 &&
              contacts.map((contact, i) => {
                const { names, phoneNumbers } = contact;
                const color = random_bg_color();
                return (
                  <div
                    key={color}
                    className="p-4 flex -z-[20] h-auto w-full cursor-pointer"
                    onClick={() => handleClick(names, phoneNumbers)}
                  >
                    <div className="flex flex-row relative w-full">
                      {names &&
                        names.map((name, i) => {
                          return (
                            <div key={i} className="flex">
                              <div
                                className={` rounded-full flex items-center justify-center relative`}
                              >
                                <BsFillCircleFill color={color} size={50} />
                                <h1 className="text-white font-bold absolute">
                                  {" "}
                                  {name.displayName[0]}
                                </h1>
                              </div>
                              <div className="flex flex-col  absolute  left-14">
                                <h1 className="pb-1 mt-auto mb-auto">
                                  {name.displayName.length > 25
                                    ? `${name.displayName.substring(0, 25)}...`
                                    : name.displayName}
                                </h1>
                              </div>
                            </div>
                          );
                        })}
                      {!names && (
                        <div
                          className={` rounded-full flex items-center justify-center relative`}
                        >
                          <BsFillCircleFill color={color} size={50} />
                          <h1 className="text-white font-bold absolute">#</h1>
                        </div>
                      )}

                      {phoneNumbers &&
                        phoneNumbers.map((phoneNumber, i) => {
                          return (
                            <h1
                              key={phoneNumber.value}
                              className="absolute left-14 bottom-0"
                            >
                              {i == 0 ? phoneNumber.value : ""}
                            </h1>
                          );
                        })}
                    </div>
                  </div>
                );
              })}
          </div>
          {localStorage.getItem("allNumsFetched") === "no" && (
            <div
              className="yellow-theme-color w-fit text-center fixed  text-white bottom-0 cursor-pointer right-0 p-2 rounded-md sm:right-1/3  sm:translate-x-1/2 m-auto"
              onClick={() => {
                if (pageToken !== "") {
                  fetchNextContacts();
                } else if (localStorage.getItem("allNumsFetched") === "no") {
                  console.log("clicked");
                  fetchNextContacts();
                } else {
                  console.log("no page token found");
                }
              }}
            >
              {fetching ? `${text?.fetchingText?.[language]}...` : `${text?.loadText?.[language]}`}
            </div>
          )}
           {noNumAlert && (
          <Alert
            showAlert={noNumAlert}
            handleOkClick={() => setNoNumAlert(false)}
            message={text?.noCallMadeText?.[language]}
          />
        )}
        </div>
      )}
    </div>
    
  );
};

export default ContactsList;
